document.addEventListener("DOMContentLoaded", function () {
  const existingSpecs = document.querySelector(
    "#specs:not([data-specs-tab-replacement])"
  );
  const replacementContent = document.querySelector(
    "[data-specs-tab-replacement]"
  );

  if (existingSpecs && replacementContent) {
    existingSpecs.outerHTML = replacementContent.outerHTML;
    replacementContent.remove(); // Remove the duplicate content
  }

  if (replacementContent) {
    replacementContent.classList.remove("hidden");
  }
});

if (Shopify.designMode) {
  document.addEventListener("shopify:block:select", function (event) {
    if (event.target.blockData.type === "jaws-specs-tab") {
      document.querySelector('[data-slug="specs"]').click();
    }
  });
}
